export default __webpack_public_path__ + "static/media/KOD0026-min.0ddf57fb.webp";